<template>
    <v-app id="company">
        
        <v-app-bar color="indigo white--text"  id="company__appbar" height="30px">
            <h3 style="margin-left:5px">Predictions for MUID:{{this.muid}}</h3>
        </v-app-bar>

        <div v-if="isloading" class="loader"></div>
        <v-container v-else id="company__container" no-gutter color="grey">


             <v-row >
                <v-col :cols="12">
                    
                    <v-card>
                        <v-list id="company__list">
                    <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content ><p><b>Original Mailing Type</b></p></v-list-item-content>
                             <v-list-item-content><p>{{mtypeNameorginal}}</p></v-list-item-content>
                             
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>

                    <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content ><p><b>Predicted Mailing Type</b></p></v-list-item-content>
                             <v-list-item-content><p>{{mailingtypename}}
                                 <v-chip
      class="ma-2"
      color="success"
       @click="saveLearning"
      outlined 
      style="cursor:pointer"
    >
      <v-icon left>
        mdi-server-plus
      </v-icon>
      Accept/Save Learning
    </v-chip>
      <v-chip
     
      class="ma-2"
      
      color="red"
      @click="removeLearning"
      style="cursor:pointer"
      outlined
    >
      Inncorrect Prediction/Remove 
    </v-chip>

                                 </p></v-list-item-content>
 
                            </v-list-item>
                            
                            <v-divider/>
                     </v-list-item-group>
                      <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content ><p><b>Original Sector</b></p></v-list-item-content>
                             <v-list-item-content><p>{{orginalsector}}</p></v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>
                      <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content><p><b>Predicted Sector</b></p></v-list-item-content>
                             <v-list-item-content><p>{{sectors}}<br>
                             <span style="color:#00a4e4"><b>Prediction Score</b><br></span>
                             <span style="color:#00a4e4" v-html="sectorpredscore"></span>
                             </p></v-list-item-content>
                            
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>
                      <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content><p><b>Original Category</b></p></v-list-item-content>
                              <v-list-item-content><p>{{orginalcategory}}</p></v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>
                      <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content><p><b>Predicted category</b></p></v-list-item-content>
                             <v-list-item-content><p>{{category }}
                             <br>
                             <span style="color:#00a4e4"><b>Prediction Score</b><br></span>
                             <span  style="color:#00a4e4" v-html="categorypredscore"></span></p></v-list-item-content>
                             
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>
                      <v-list-item-group >
                          <v-list-item>
                           <v-list-item-content><p><b>Secondary Companies</b></p></v-list-item-content>
                             <v-list-item-content><p>{{predcompanies.toUpperCase() }}</p></v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                     </v-list-item-group>
                      </v-list>
                      
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </v-app>
</template>

<script>
export default {
    name: 'Company',
    data: () => ({
        data: '',
        is_queue: '',
        training_datetime: '',
        restoredata: [],
        working: false,
        companyList: [],
        choosenCompany: '',
        addCompany: '',
        muid: '',
        sectors:'',
        category:'',
        predcompanies:'',
        isloading:true,
        sectorpredscore:'',
        categorypredscore:'',
        orginalsector:'',
        orginalcategory:'',
        orginal_mailing_type:'',
        mailingtypename:'',
        predicted_mailing_type:'',
        mtypeNameorginal:''
    }),
    mounted() {
       // this.reset()
        this.getSector()
        this.getCategory()
        this.getMailingType()
        this.getSecondaryCompany()
    },
    methods: {
        saveLearning:function(){
        console.log("learning")

    },removeLearning:function(){

    },
        reset: function() {
            var view = this
            view.addCompany = ''
            view.muid = view.$route.params.muid
            let path = (view.$route.name == 'companynew')?view.$url('COMPANY2019') + 'Company/' + view.muid:view.$url('ALL_PREDICTIONS') + '/' + view.muid
            view.$fetch({
                url: path,
                type: 'GET',
                crossDomain: true,  
            },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                view.isloading = false
                view.sectors = response.sectors
                view.category = response.cateegory
                view.predcompanies=response.companies
                view.sectorpredscore=response.sectorpredscore
                view.categorypredscore=response.categorypredscore
                view.orginalsector = response.orginalsector
                view.orginalcategory = response.orginalcategory
                view.mailingtypename = response.mailingtypename
                view.mtypeNameorginal = response.mtypeNameorginal

                view.training_datetime = typeof response.training_datetime === 'undefined' ? '' : response.training_datetime
                view.is_queue = typeof response.is_queue === 'undefined' ? '' : response.is_queue
                view.restoredata = typeof response.restoredata === 'undefined' ? '' : response.restoredata
                view.data = typeof response.data === 'undefined' ? '' : response.data
                view.addCompany = ''
            }).catch(function(e) {
                console.log(e)
            })
            console.log(""+path)
        },getSector: function() {
            var view = this
            view.muid = view.$route.params.muid
            let path = view.$url('SECTORPRED_URL') + '/' + view.muid
           
            view.$fetch({
                url: path,
                type: 'GET'
            },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                view.isloading = false
                view.sectors = response.sectors
                view.sectorpredscore=response.sectorpredscore
                view.orginalsector = response.orginalsector
            }).catch(function(e) {
                console.log(e)
            })
        },getCategory: function() {
            var view = this
            view.muid = view.$route.params.muid
            let path = view.$url('CATEGORYPRED_URL') + '/' + view.muid
           
            view.$fetch({
                url: path,
                type: 'GET'
            },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                view.isloading = false
                 view.category = response.cateegory
                view.orginalcategory = response.orginalcategory
                view.categorypredscore=response.categorypredscore
            }).catch(function(e) {
                console.log(e)
            })
        },getMailingType: function() {
            var view = this
            view.muid = view.$route.params.muid
            let path = view.$url('MAILINGTYPEPRED_URL') + '/' + view.muid
           
            view.$fetch({
                url: path,
                type: 'GET'
            },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                view.isloading = false
                 view.mailingtypename = response.mailingtypename
                 view.mtypeNameorginal = response.mtypeNameorginal
            }).catch(function(e) {
                console.log(e)
            })
        },getSecondaryCompany: function() {
            var view = this
            view.muid = view.$route.params.muid
            let path = view.$url('SECCOMPANYPRED_URL') + '/' + view.muid
           
            view.$fetch({
                url: path,
                type: 'GET'
            },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                view.isloading = false
                view.predcompanies=response.companies
            }).catch(function(e) {
                console.log(e)
            })
        },
        chooseCompany: function(c) {
            this.companyList = []
            this.choosenCompany = c.companyName
            this.addCompany = this.choosenCompany
        },
        commitAddCompany: function() {
            var view = this,
                requestPayload = {}
            requestPayload['companyName'] = view.choosenCompany
            requestPayload['muid'] = view.muid
            view.$fetch({
                url: view.$url('COMPANY') + 'Company/' + view.muid,
                type: 'POST',
                data: JSON.stringify(requestPayload),
                contentType: "application/json",
            },{
                operation: 'add',
                vueScope: view
            }).then(function() {
                view.reset()
            }).catch(function(e) {
                console.log(e)
            })
        },
        status: function(s) {
            return parseInt(s.status) === parseInt(1) ? 'New Company Added' : 'Company Removed'
        },
        onFocus: function() {
            this.choosenCompany = ''
        },
        removeCompany: function(id) {
            var view = this
            view.$fetch({
                type: 'DELETE',
                url: view.$url('COMPANY') + 'Company/' + id,
            },{
                operation: 'delete',
                vueScope: view
            }).then(function() {
                view.reset()
            }).catch(function(e) {
                console.log(e)
            })
        },
        removeSpaceyMaster: function(id) {
            var view = this
            view.$fetch({
                type: 'DELETE',
                url: view.$url('COMPANY') + 'SpacyMaster/' + id,
            },{
                operation: 'delete',
                vueScope: view
            }).then(function() {
                view.reset()
            }).catch(function(e) {
                console.log(e)
            })
        },
        getCssId: function(s) {
            return parseInt(s) === parseInt(1) ? '' : 'company__cuttext'
        },
        restoreCompany: function(d) {
            var view = this,
                requestPayload = {}
            requestPayload['companyId'] = d.company_id
            requestPayload['actionid'] = d.id
            view.$fetch({
                url: view.$url('COMPANY') + 'companyRestore/' + view.muid,
                type: 'POST',
                data: JSON.stringify(requestPayload),
                contentType: "application/json",
            },{
                operation: 'add',
                vueScope: view
            }).then(function() {
                view.reset()
            }).catch(function(e) {
                console.log(e)
            })
        }
    },
    watch: {
        addCompany: function(n) {
            var view = this
            if (parseInt(view.choosenCompany.length) === parseInt(0)) {
                if (n.length > 2) {
                    if (!view.working) {
                        view.working = !view.working
                        view.$fetch({
                            url: view.$url('COMPANY') + 'companyName/' + n,
                            type: 'GET'
                        },{
                operation: 'view',
                vueScope: view
            }).then(function(response) {
                            if (response.length > 0) {
                                response.forEach(function(o) {
                                    view.companyList.push(o)
                                })
                            }
                            view.working = !view.working
                        }).catch(function(e) {
                            console.log(e)
                        })
                    }
                }
            }
        }
    }
}
</script>

<style lang='sass' scoped>
@import './../assets/sass/company'
</style>